import { render, staticRenderFns } from "./productUnit.vue?vue&type=template&id=2a754d33&"
import script from "./productUnit.vue?vue&type=script&lang=js&"
export * from "./productUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports